import CircularChart from "./circularChart.container";
export default CircularChart